module.exports = __webpack_public_path__ + "img/caution.59f594e5.png";